import { IUserUiStateProject } from '@app/api/interfaces/user-ui-state-project.interface';

export const mainProjectSelection = 'mainProjectSelection';

export interface IMainProjectSelectionState {
  loading: boolean;
  saving: boolean;
  initialized: boolean;
  uiState: IUserUiStateProject;
}

export const initialMainProjectSelectionState: IMainProjectSelectionState = {
  loading: false,
  saving: false,
  initialized: false,
  uiState: {},
};
